import {IconButton} from 'quickstart/components/controls/IconButton'
import type {Opt} from 'quickstart/types'
import type {ComponentProps} from 'react'

export const ClearButton = (
  props: Opt<ComponentProps<typeof IconButton>, 'icon'>,
) => (
  <IconButton
    hoverable={false}
    icon="close"
    size="xs"
    title="Clear"
    {...props}
    style={{
      color: 'var(--eg-theme-colors-textColorLight)',
      ...props.style,
    }}
  />
)
